// extracted by mini-css-extract-plugin
export var compactFilters = "_ev-4";
export var detailImage = "_ev-1";
export var dropdownContainer = "_ev-2";
export var imageContainer = "_ev-0";
export var selectedCard = "_ev-3";